import {
  onCreditCardApplyNow,
  onCreditCardfromHostedAppApplyNow,
  selectOneClickApplicationOffer,
  selectDetailsOffer,
} from 'actions/offers.actions';
import { setPagePosition as setPagePositionAction } from 'actions/tracking.actions';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { openNewTab } from 'helpers/domHelper';
import { withRouter } from 'react-router-dom';
import {
  CLICK,
  CLICK_PREQUAL,
} from 'externals/_tracking/types/eventTypes.constants';
import { cleanPopupPaths } from 'helpers/path.helper';
import { getFullAttributes } from 'helpers/tracking.helpers';
import { useLogger } from 'hook/error.hook';
import VisibilitySensor from 'react-visibility-sensor';
import {
  useFingerprintedOfferState,
  useOptimizedFingerprintedOfferState,
  useViewOfferWithFingerprint,
} from 'hook/helper.hook';
import CarouselCreditCardOffer from 'components/Offers/CarouselCreditCard';
import { replaceCardsCtaByProductKey } from 'helpers/offer.helpers';
import { useFlag } from 'hook/flag.hook';
import { useConfig } from 'hook/config.hook';
import { OVERVIEW } from 'types/mrph.pages.constants';

const CreditCardOfferHolder = props => {
  const { offerMetadata } = props;
  const { page } = useSelector(state => {
    return { page: state.page };
  });

  const showRedesignDetail = useFlag('show_redesign_detail_page');
  const capitalOneCardModuleFlag = useFlag('capitalone_card_module_2025', {
    defaultConfig: {
      borderColor: offerMetadata?.cardUiModuleConfiguration?.borderColor,
      borderTitle: offerMetadata?.cardUiModuleConfiguration?.borderTitle,
    },
    forceDefaultConfigForDisabledOptimizely: true,
  });
  const webCtaOcfCtaFlag = useFlag('cc_offer_holder_web_cta_ocf_cta', {
    defaultConfig: null,
    forceDefaultConfigForDisabledOptimizely: true,
  });

  const secureMinimumDepositFlag = useFlag(
    'cc_offer_holder_secure_minimum_deposit',
    {
      defaultConfig: null,
      forceDefaultConfigForDisabledOptimizely: true,
    },
  );

  const offerBonusTrayFlag = useFlag('cc_offer_holder_show_bonus_offer_tray', {
    defaultConfig: null,
    forceDefaultConfigForDisabledOptimizely: true,
  });

  const hostedAppFlag = useFlag('cc_offer_holder_hosted_app', {
    defaultConfig: null,
    forceDefaultConfigForDisabledOptimizely: true,
  });

  const capOneOverwriteLinkUrlFlag = useFlag(
    'cc_offer_holder_cap_one_overwrite_link_url',
    {
      defaultConfig: null,
      forceDefaultConfigForDisabledOptimizely: true,
    },
  );

  const dispatch = useDispatch();
  const logger = useLogger({
    name: 'CreditCardOfferHolder',
    categories: ['offers', `CREDITCARD-${offerMetadata.productKey}`],
  });

  const setPagePosition = v => dispatch(setPagePositionAction(v));
  const isModal = props.isModal;

  const hideNAFields = offerMetadata.productKey === 'CHASE_FREEDOM_UNLIMITED';
  const pqModal =
    props.extraAttributes && props.extraAttributes.pqModal
      ? props.extraAttributes.pqModal
      : null;
  const fingerprint = pqModal
    ? `CREDIT_CARD-${props.offerMetadata.productKey}-${props.pagePosition}-${pqModal}`
    : `CREDIT_CARD-${props.offerMetadata.productKey}-${props.pagePosition}`;

  const overWriteCtaAndApplyLink =
    capOneOverwriteLinkUrlFlag?.config?.card_to_modify_cta_link?.cards?.find(
      c => c.productKey === offerMetadata?.productKey,
    );

  const minimunDeposit =
    secureMinimumDepositFlag?.config?.secured_minimum_deposit_cards?.cards?.find(
      c => c.productKey === offerMetadata?.productKey,
    );

  const isOcfCardinExclusionList =
    webCtaOcfCtaFlag?.config?.ocf_cards_cta_exclusion_list?.cards?.find(
      c => c.productKey === offerMetadata?.productKey,
    );

  const overWriteCtaOcfCards =
    webCtaOcfCtaFlag?.config?.ocf_cards_cta &&
    props.isOcfPage &&
    !isOcfCardinExclusionList
      ? webCtaOcfCtaFlag?.config?.ocf_cards_cta
      : null;

  const isCardInCtaExclusionList =
    webCtaOcfCtaFlag?.config?.overwrite_cards_cta_w_exclusion_list?.cards?.find(
      c => c.productKey === offerMetadata?.productKey,
    );

  const overWriteCardsCtawExclusionListLabel =
    !isCardInCtaExclusionList && !props?.isOcfPage
      ? webCtaOcfCtaFlag?.config?.overwrite_cards_cta_w_exclusion_list?.cta
      : null;

  const buttonLabel = replaceCardsCtaByProductKey(
    overWriteCardsCtawExclusionListLabel,
    props.offerMetadata?.ctaActionTitle,
    overWriteCtaAndApplyLink?.cta,
    overWriteCtaOcfCards?.cta,
  );

  const reviewRating =
    !props.offerMetadata?.reviewRating ||
    props.offerMetadata?.reviewRating === 0
      ? 'N/A'
      : (Math.round(10 * props.offerMetadata?.reviewRating) / 10).toFixed(1);

  const fullAttr = getFullAttributes({
    partner: props.partner,
    pagePosition: props.pagePosition,
    modulePosition: props.modulePosition,
    offerMetadata: offerMetadata,
    position: props.position,
    extraAttributes: props.extraAttributes,
    attributes: {},
    isModal: isModal,
    isPrequal: props.isPrequal,
    containerType: props.containerType,
    includeBackendRefCode: props.isOcfPage,
    moduleHeading: props.moduleHeading,
  });
  const defaultEventHandler = (name, attributes = {}) => {
    const fullAttributes = getFullAttributes({
      partner: props.partner,
      pagePosition: props.pagePosition,
      modulePosition: props.modulePosition,
      offerMetadata: offerMetadata,
      position: props.position,
      extraAttributes: props.extraAttributes,
      attributes: attributes,
      isModal: isModal,
      isPrequal: props.isPrequal,
      containerType: props.containerType,
      includeBackendRefCode: props.isOcfPage,
      moduleHeading: props.moduleHeading,
    });
    props.eventHandler(name, fullAttributes);
  };
  const { onVisibilityChange } = useOptimizedFingerprintedOfferState(
    fingerprint,
    {
      defaultEventHandler,
      fullAttr,
      isModal,
    },
  );

  const [isLoading, setIsLoading] = useState(false);

  let showApplyNow = true;

  const partnersCustomTrackingMeta = props.partnersCustomTrackingMeta;

  const __onApplyClick = eventProps => {
    if (
      hostedAppFlag?.config?.hosted_app_cards?.cards?.includes(
        offerMetadata?.productKey,
      )
    ) {
      dispatch(selectOneClickApplicationOffer(offerMetadata));
      dispatch(
        onCreditCardfromHostedAppApplyNow(eventProps, {
          ...props,
          defaultEventHandler,
          logger,
          offerMetadata,
          partnersCustomTrackingMeta,
        }),
      );
    } else {
      dispatch(
        onCreditCardApplyNow(eventProps, {
          ...props,
          defaultEventHandler,
          logger,
          setIsLoading,
          isLoading,
          offerMetadata,
          partnersCustomTrackingMeta,
          urlFromFlag: !overWriteCardsCtawExclusionListLabel
            ? overWriteCtaAndApplyLink?.link
            : null,
          creditOnePrefillEnabled:
            config?.creditCardOfferHolder?.creditOnePrefillEnabled,
        }),
      );
    }
  };

  const onApplyClick = e => {
    e.preventDefault();
    __onApplyClick({
      'Click Type': buttonLabel,
    });
  };

  const onApplyClickForImage = e => {
    e.preventDefault();
    const clickTypeAttr = {
      'Click Type': 'Card Image',
    };
    __onApplyClick(clickTypeAttr);
  };

  const onApplyClickForName = e => {
    e.preventDefault();
    const clickTypeAttr = {
      'Click Type': 'Card Name',
    };
    __onApplyClick(clickTypeAttr);
  };

  const onApplyClickForDetails = e => {
    e.preventDefault();
    const clickTypeAttr = {
      'Click Type': 'Card Details',
    };
    __onApplyClick(clickTypeAttr);
  };

  const onMouseOverApprovalOdds = e => {
    defaultEventHandler(CLICK, {
      'Click Type': 'ApprovalOdds',
    });
  };

  const clickPrequalificationHandler = (e, extraAttributes) => {
    const formattedIssuer = offerMetadata.issuer
      .split(' ')
      .join('_')
      .toUpperCase();
    const path = props.location.pathname;
    const newPath = cleanPopupPaths(path);
    setPagePosition(props.pagePosition);
    const finalPath = `${newPath}/credit-card-pre-approval/${formattedIssuer}`;
    props.history.replace(finalPath);
    defaultEventHandler(
      CLICK_PREQUAL,
      Object.assign(
        {
          'Click Type': 'Prequal',
        },
        extraAttributes,
      ),
    );
  };

  const onMouseClickReview = e => {
    e.preventDefault();
    defaultEventHandler(CLICK, {
      'Click Type': 'Reviews',
    });
    const currentPath = props.location.pathname;
    const cleanPath = cleanPopupPaths(currentPath);
    setPagePosition(props.pagePosition);

    let finalUrl;

    if (showRedesignDetail?.config?.shown) {
      dispatch(selectDetailsOffer(offerMetadata));
      finalUrl = `${cleanPath}/offers/details/${offerMetadata?.creditCardId}#reviews`;
    } else {
      finalUrl = `${cleanPath}/offerDetails/creditCard/${offerMetadata?.creditCardId}#reviews`;
    }

    props.history.replace(finalUrl);
  };

  const onMouseClickDetails = e => {
    const currentPath = props.location.pathname;
    const currentLocationSearch = props?.location?.search;
    const cleanPath = cleanPopupPaths(currentPath);
    setPagePosition(props.pagePosition);
    defaultEventHandler(CLICK, {
      'Click Type': 'Card Details',
    });
    let finalUrl;
    if (showRedesignDetail?.config?.shown) {
      dispatch(selectDetailsOffer(offerMetadata));
      finalUrl = `${cleanPath}/offers/details/${offerMetadata.creditCardId}${currentLocationSearch}`;
    } else {
      finalUrl = `${cleanPath}/offerDetails/creditCard/${offerMetadata.creditCardId}${currentLocationSearch}`;
    }
    props.history.replace(finalUrl);
  };

  const clickTcHandler = e => {
    if (e && e.preventDefault) e.preventDefault();
    defaultEventHandler(CLICK, {
      'Click Type': 'See Rates and Fees',
    });
    openNewTab(offerMetadata.tcUrl);
  };

  const clickFullTcHandler = e => {
    if (e && e.preventDefault) e.preventDefault();
    defaultEventHandler(CLICK, {
      'Click Type': 'Show Bonus Offer',
    });
    openNewTab(offerMetadata?.bonusOfferInfo?.bonusLink?.linkUrl);
  };

  const { config } = useConfig();

  const hideCreditLimitByConfig = config?.hideCreditLimit?.cards?.find(
    c => c.productKey === offerMetadata?.productKey,
  );

  const goToViewProgramTerms = () => {
    openNewTab(config?.creditCardOfferHolder?.sesameGuaranteeProgramTermsLink);
  };

  const showBadge =
    props.offerMetadata?.badgeEnabledFlag && props.offerMetadata?.badgeLabel;

  // this is just to do some debug on prod for CCI ranking , we will remove it
  // we should only fire this on overview page
  const [state, setState] = useFingerprintedOfferState(fingerprint);
  const { isViewTriggered } = state;
  const setIsViewTriggered = isViewTriggered => setState({ isViewTriggered });

  useViewOfferWithFingerprint(
    fullAttr,
    isModal,
    isViewTriggered,
    setIsViewTriggered,
    fingerprint,
    page?.pageName === OVERVIEW,
  );
  const showApprovalOddsBadgeFlag = useFlag('approvaloddsbadgehide_web');
  const excludedApprovalOdds =
    showApprovalOddsBadgeFlag?.config?.approval_odds?.approvalOdds || [];
  const excludedProducts =
    showApprovalOddsBadgeFlag?.config?.product_keys?.cards || [];
  const productMatches = excludedProducts.includes(offerMetadata?.productKey);
  const approvalOddsMatches = excludedApprovalOdds.includes(
    offerMetadata?.observedApprovalOdds,
  );
  let showApprovalOddsBadge;
  if (excludedProducts.length === 0 && excludedApprovalOdds.length === 0) {
    showApprovalOddsBadge = false;
  } else if (excludedProducts.length === 0 && approvalOddsMatches) {
    showApprovalOddsBadge = true;
  } else if (excludedApprovalOdds.length === 0 && productMatches) {
    showApprovalOddsBadge = true;
  } else {
    showApprovalOddsBadge = productMatches && approvalOddsMatches;
  }
  return (
    <CardTemplateSwitch
      {...props}
      offerMetadata={offerMetadata}
      offerImageLinkUrlProxy={`${offerMetadata?.imageLink}`}
      clickApplyHandler={onApplyClick}
      clickApplyCardNameHandler={onApplyClickForName}
      clickApplyImageHandler={onApplyClickForImage}
      clickApplyDetailsHandler={onApplyClickForDetails}
      clickReviewHandler={onMouseClickReview}
      clickDetailsHandler={onMouseClickDetails}
      clickTcHandler={clickTcHandler}
      clickFullTcHandler={clickFullTcHandler}
      hoverApprovalOddsHandler={onMouseOverApprovalOdds}
      clickPrequalificationHandler={clickPrequalificationHandler}
      hideNAFields={hideNAFields}
      showApplyNow={showApplyNow}
      seenPixel={
        <VisibilitySensor onChange={onVisibilityChange}>
          <div className="invisible-pixel" />
        </VisibilitySensor>
      }
      reviewRating={reviewRating}
      loading={isLoading}
      buttonLabel={buttonLabel}
      hideCreditLimitByConfig={hideCreditLimitByConfig}
      minimunDeposit={minimunDeposit}
      goToViewProgramTerms={goToViewProgramTerms}
      showBadge={showBadge}
      showBonusOfferTray={offerBonusTrayFlag?.config?.showBonusOfferTray}
      cardUiModuleConfiguration={capitalOneCardModuleFlag?.config}
      showRewardAndBonus={offerBonusTrayFlag?.config?.showRewardAndBonus}
      showApprovalOddsBadge={showApprovalOddsBadge}
    />
  );
};

const CardTemplateSwitch = props => {
  if (props.creditCardTemplate) {
    return <props.creditCardTemplate {...props} />;
  } else {
    return <CarouselCreditCardOffer {...props} />;
  }
};

const connectedCreditCardOfferHolder = withRouter(CreditCardOfferHolder);

export default connectedCreditCardOfferHolder;
